import { render, staticRenderFns } from "./dz_air_control.vue?vue&type=template&id=1b2ebe1e&"
import script from "./dz_air_control.vue?vue&type=script&lang=js&"
export * from "./dz_air_control.vue?vue&type=script&lang=js&"
import style0 from "./dz_air_control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports